export default __webpack_public_path__ + "static/blob16-69b8dddf5af34a1f7148a7fc105e43a7.svg";